// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-design-content[data-v-3fe6b1ca] {\n  height: calc(100vh - 150px);\n}", ""]);
// Exports
module.exports = exports;
